// extracted by mini-css-extract-plugin
export var embla = "patient-slider-physiolymp-module--embla--RVI29";
export var embla__container = "patient-slider-physiolymp-module--embla__container--a4Txe";
export var embla__slide = "patient-slider-physiolymp-module--embla__slide--QRp6j";
export var embla__slide__selected = "patient-slider-physiolymp-module--embla__slide__selected--q9dH4";
export var logo = "patient-slider-physiolymp-module--logo--5iWlz";
export var title = "patient-slider-physiolymp-module--title--IZ7Ri";